<template>
  <div class="modal fade" id="loginDialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document" >
      <div class="modal-content" style="width: 600px;">
        <div class="content-box-right">
        <div class="login-box">
          <div class="login-left">
            <div class="wx-login login-bc">
              <div class="wx-login-img" ></div>
            </div>
            <div class="connect" style="width:100%;;height: 30px;line-height: 30px;">
              <!--<p>快捷</p>-->
              <div style="width:50%;float:left;text-align: center;">
                <span class="pw-login login-title-border pass-login">密码登陆</span>
              </div>
              <div style="width:50%;float:left;text-align: center;">
                <span class="ph-login telephone-login">手机登陆</span>
              </div>
              <div class="clear"></div>
            </div>
            <form onsubmit="return false;" method="post" id="input-login">
              <div id="password-login">
                <input type="text" v-model="loginInfo.username" name="username" class="username" placeholder="请输入您的用户名！">
                <input type="password" style="margin-top: 15px" v-model="loginInfo.password" name="password" class="password"
                       placeholder="请输入您的用户密码！">
                <div id="mpanel3" style="margin-top: 15px"></div>
              </div>
              <div id="phone-login" style="display: none;">
                <input type="text" v-model="loginInfo.telephone" name="telephone" class="telephone" placeholder="手机号码">
                <div style="margin-top: 15px;border:1px solid #CCCCCC;border-radius: 3px;height: 33px;line-height: 33px;">
                  <input type="Captcha" v-model="loginInfo.code" class="Captcha" name="Captcha" placeholder="验证码" style="width:70%;border:none !important;">
                  <button class="Captcha-click" v-on:click="handleCode" style="" v-text="hintInfo.buttonText">发送验证码
                  </button>
                </div>
                <div style="clear:both"></div>
              </div>
              <div id="chooseType" style="margin-top: 15px;">
                <div style="width:50%;float:left;text-align: center;">
                  <input type="radio" v-model="loginInfo.type" value="0" name="userType" checked>&nbsp;个人用户
                </div>
                <div style="width:50%;float:left;text-align: center;">
                  <input type="radio" v-model="loginInfo.type" value="1" name="userType">&nbsp;企业用户
                </div>
                <div class="clear"></div>
              </div>
              <button type="button" v-text="state.loginBtnMessage" id="submit" class="submit_button" v-if="loginMethod==1" >登录</button>
              <button type="button" v-text="state.loginBtnMessage" id="submit_phone" class="submit_button" v-if="loginMethod==2" v-on:click="handleTelephoneBtn">登录</button>
              <!--<div class="error"><span>+</span></div>-->
              <div id="zc">
                <div style="width:100%;float:left;text-align: right;">
                  <a href="https://www.hiturnjob.com/forget_password.html">忘记密码</a>
                </div>
                <div class="clear"></div>
              </div>
            </form>
            <div class="wx-login-box" style="display: none;">

              <div style="text-align: center;color: #f8b62b;font-size: 18px;margin-bottom: 10px;" class="qr-login">
                微信登陆
              </div>
              <div id="rq-code-login">
                <img src="@/assets/images/ewm.png" style="width: 180px;" />
              </div>
              <div class="no-wx">
                返回
              </div>
            </div>
          </div>
          <div class="login-right">
            <div style="font-size:14px;color: #999999;margin-top: 20px;text-align: center;">关注海豚人才网</div>
            <div style="margin-top: 10px;">
              <img src="@/assets/images/hiturn-ewm.jpg" style="width: 100%;"/>
            </div>
            <div id="zc">
              <div style="float:left;text-align: left;">
                <a href="https://www.hiturnjob.com/register_web.html">个人注册</a>
              </div>
              <div style="float:right;text-align: right;">
                <a href="https://www.hiturnjob.com/register_enterprise.html">企业注册</a>
              </div>
              <!-- <div style="width:50%;float:left;text-align: right;">
                <a href="forget_password.html">忘记密码</a>
              </div> -->
              <div class="clear"></div>
            </div>
          </div>
          <div style="clear:both;"></div>
        </div>
      </div>
      </div>
    </div>
    <span hidden ref="realLogin"  v-on:click="handleLoginBtn">登录0</span>
  </div>
</template>

<script>
    import Checked from "@/views/fair/commons/check";
    import {login, loginByTelephone} from "@/api/user"
    import {sendSms} from "@/api/sms"
    import {setToken} from '@/utils/auth'
    import Toastr from "toastr2"
    import verify from '@/assets/js/verify.js'
    import wxLogin from '@/assets/js/wxLogin.js'
    import md5 from '@/utils/md5.js'

    export default {
        name: "fair_detail",
        props:["loginType", "loginTitle"],
        data() {
            return {
                loginInfo: {
                    type: 0,
                    username:null,
                    password:null
                },
                hintInfo: {
                    buttonText: '手机验证码'
                },
                state: {
                    waitMessage: false,
                    loginBtnMessage: '登录'
                },
                loginMethod:1,
                toast: null,
                initCode: false
            }
        },
        mounted() {
          console.log(this.loginInfo)
           this.toast = new Toastr()
            let this_ = this
            $(".ph-login").on("click", function() {
                $(".ph-login").addClass("login-title-border");
                $(".pw-login").removeClass("login-title-border");
                $("#password-login").hide();
                $("#phone-login").show();
            })
            $(".qr-login").on("click",function(){
                this_.loginMethod = 3
            })
            $(".telephone-login").on("click",function(){
                this_.loginMethod = 2
            })
            $(".pass-login").on("click",function(){
                this_.loginMethod = 1
            })

            $(".pw-login").on("click", function() {
                $(".pw-login").addClass("login-title-border");
                $(".ph-login").removeClass("login-title-border");
                $("#password-login").show();
                $("#phone-login").hide();
            })

            $(".no-wx").on("click",function(){

                $(".wx-login").show();
                $("#input-login").show();
                $(".connect").show();
                $(".wx-login-box").hide();
            })

            $(".wx-login-img").on("click", function() {
                $(".wx-login").hide();
                $("#input-login").hide();
                $(".connect").hide();
                $(".wx-login-box").show();
                var obj = new WxLogin({
                    self_redirect: false,
                    id: "rq-code-login",
                    appid: "wx29326039d5664095",
                    scope: "snsapi_login",
                    redirect_uri: encodeURIComponent("http://app.hiturnjob.com/wxUnion.html?method=login"),
                    state: "checked",
                    style: "black",
                    href: "https://www.hiturnjob.com/qrcode.css"
                });

            })
        },
        methods: {
            resetForm(){
                this.loginForm = {}
            },
            handleLoginBtn0(){
                alert(this.loginInfo.username)
                //this.$refs.realLogin.click();
            },
            updateCode(){
              $("#loginDialog").modal()
              const this_ = this
              if(!this_.initCode){
                this.$nextTick(()=>{
                  $('#mpanel3').codeVerify({
                        type: 2,
                        figure: 10, //位数，仅在type=2时生效
                        arith: 0, //算法，支持加减乘，不填为随机，仅在type=2时生效
                        width: '200px',
                        height: '50px',
                        fontSize: '30px',
                        btnId: 'submit',
                        ready: function() {
                          this_.initCode=true
                        },
                        success: function() {
                            this_.handleLoginBtn();
                        },
                        error: function() {
                            if(this_.loginMethod==1){
                                this_.toast.warning("验证码错误");
                            }
                        }
                    });
                })
              }
            },
            handleLoginBtn: function() {
                this.state.loginBtnMessage = "正在登录"
                let loginInfo = this.loginInfo
                loginInfo['password'] = md5.hex_md5(loginInfo.password);
                login(loginInfo).then(response => {
                    const token = response.accessToken
                    setToken(token)
                    this.$store.dispatch("user/loadAbility").then(res => {
                        this.$parent.refreshLogin();
                    }).catch(error => {
                        console.log(error)
                        toast.warning(error)
                    })
                    $('#loginDialog').modal('hide');
                }).catch(error => { // 请求失败处理
                    console.log(error)
                    this.state.loginBtnMessage = "登录"
                })
            },
            handleCode: function() {
                if (!this.state.waitMessage) {
                    let telephone = this.loginInfo.telephone
                    if (telephone != null) {
                        let data = {
                            phoneNumbers: telephone
                        };
                        this.state.waitMessage = true;
                        let time = 60;
                        let this_ = this;
                        let interval = setInterval(function() {
                            if (time < 0) {
                                this_.hintInfo.buttonText = '获取验证码';
                                this_.state.waitMessage = false;
                                window.clearInterval(interval);
                            } else {
                                time--;
                                this_.hintInfo.buttonText = time + ' s ';
                            }
                        }, 1000)
                        sendSms(data).then(response => {
                            this_.toast.success("短信已发送");
                        }).catch(error => { // 请求失败处理
                            window.clearInterval(interval);
                            this_.hintInfo.buttonText = '获取验证码';
                            this.state.waitMessage = false
                            console.log(error)
                        })
                    } else {
                        this.toast.warning("请输入正确的手机号");
                    }
                }
            },
            handleTelephoneBtn: function() {
                if(this.loginInfo.telephone==null){
                    this.toast.warning('请输入手机号')
                    return
                }
                if(this.loginInfo.code==null){
                    this.toast.warning('请输入验证码')
                    return
                }
                loginByTelephone(this.loginInfo).then(response => {
                    const token = response.accessToken
                    setToken(token)
                    this.$store.dispatch("user/loadAbility").then(res => {
                        this.$parent.refreshLogin();
                    }).catch(error => {
                        console.log(error)
                        toast.warning(error)
                    })
                    $('#loginDialog').modal('hide');
                }).catch(error => { // 请求失败处理
                    console.log(error)
                })
            }
        },
        watch:{
        },
        computed: {
        },
        components:{Checked}
    }
</script>

<style scoped>
  .clear {
    clear: both;
  }

  .login-bc {
    background: url(../../../assets/images/wxdl.gif);
    background-size: 100% 100%;
    width: 150px;
    height: 32.5px;
    margin-top: -30px;
    margin-left: -20px;
  }

  input:focus,
  button:focus {
    outline: none;
  }

  .wx-login-img
  {
    width: 25px;height: 25px;float: left;margin-top: 7px;cursor: pointer;
  }
  .content-box-right {
    width: 600px;
    height: 100%;
  }

  .login-box {
    width: 600px;
    background-color: #FFFFFF;
    /* height: 300px; */
    border-radius: 5px;
    box-shadow: 0px 0px 20px #999999;
    padding: 30px
  }
  .login-left{
    width: 330px;
    float: left;
    padding-right: 30px;
    border-right-width: 1px;
    border-right-color: #CCCCCC;
    border-right-style: dashed;

  }
  .login-right{
    width: 120px;
    float: left;
    margin-left: 30px;
  }

  .login-left .connect {
    /* color: #8ec31f; */
    color: #666666;
    font-size: 18px;
    margin-bottom: 15px;
  }

  .login-left .username {
    width: 100%;
    height: 35px;
    color: #999999;
    border: #Cccccc 1px solid;
    border-radius: 3px;
    padding: 10px;
    font-size: 14px;
  }

  .login-left .password {
    width: 100%;
    height: 35px;
    color: #999999;
    border: #Cccccc 1px solid;
    border-radius: 3px;
    padding: 10px;
    font-size: 14px;
  }

  .login-left .telephone {
    width: 100%;
    height: 35px;
    color: #999999;
    border: #Cccccc 1px solid;
    border-radius: 3px;
    padding: 10px;
  }

  .Captcha {
    height: 33px !important;
    line-height: 33px;
    color: #999999;
    border: #Cccccc 1px solid !important;
    border-radius: 3px;
    border: none;
    padding: 10px;
  }

  input:focus,
  button:focus {
    outline: none;
  }

  .Captcha-click {
    width: 30%;
    float: right;
    background: none;
    border: none;
    border-left: #CCCCCC 1px solid;
    color: #999999;
    font-size: 12px;
    cursor: pointer;
  }

  .verify-code {
    height: 35px !important;
    line-height: 35px !important;
    cursor: pointer;
  }

  .submit_button {
    width: 100%;
    margin-top: 15px;
    height: 35px;
    background-color: #f8b62b;
    border: 1px solid #f8b62b;
    color: #FFFFFF;
    border-radius: 5px;
    cursor: pointer;
  }

  .login-box radio {
    color: #8ec31f;
    background: #8ec31f;
  }

  #zc {
    margin-top: 15px;
  }

  #zc a {
    /* color: #8ec31f; */
    color: #999999;
  }

  #zc a:hover {
    text-decoration: underline;
    color: #f8b62b;
  }

  .no-wx{
    text-align: center;
    /* color: #8ec31f; */
    color: #f8b62b;
    font-size: 14px;
    cursor: pointer;
  }

  .footer {
    height: 180px;
  }

  .footer-box {
    text-align: center;
    color: #808080;
    padding-top: 60px;
    padding-bottom: 30px;
  }

  .login-title-border {
    font-weight: bolder;
    color: #f8b62b;
  }

  .pw-login,
  .ph-login {
    cursor: pointer;
  }

  #rq-code-login iframe{
    margin-top: -20px;
    margin-left: -20px;
    max-height: 290px;
  }
</style>



// WEBPACK FOOTER //
// src/views/fair/commons/login.vue